// Track the origin of the most recent logout invocation so that global handlers
// can distinguish between user-initiated and system-initiated flows.

export type LogoutSource = "manual" | "system" | "account_locked";

let currentLogoutSource: LogoutSource | null = null;

export const setLogoutSource = (source: LogoutSource): void => {
  currentLogoutSource = source;
};

export const consumeLogoutSource = (): LogoutSource | null => {
  const source = currentLogoutSource;
  currentLogoutSource = null;
  return source;
};

export const resetLogoutSource = (): void => {
  currentLogoutSource = null;
};

export const getLogoutSource = (): LogoutSource | null => currentLogoutSource;



